import { ABSmartlyContextType, Variant } from '../types';

const FORCED_TEST_PREFIX = 'test_';

const getVariants = (experiment: { variants: unknown[] }) => {
  return experiment.variants as Variant[];
};

export const getVariantsArray = (
  context: ABSmartlyContextType,
  experimentId: string,
  defaultValue = 'control',
): readonly string[] => {
  const experiment = context.data().experiments?.find(exp => exp.name === experimentId);
  if (!experiment) {
    return [defaultValue];
  }
  const allExperimentVariants = getVariants(experiment);
  return allExperimentVariants.map(variant => variant.name);
};

export default function setupForcedVariants(
  context: ABSmartlyContextType,
  experimentPrefix = FORCED_TEST_PREFIX,
) {
  const experimentsFromUrlParams = window?.location?.search
    ?.split('?')[1]
    ?.split('&')
    ?.filter(param => param.startsWith(experimentPrefix))
    ?.map(param => param.slice(experimentPrefix.length));

  const forcedExperiments: string[] = [];
  experimentsFromUrlParams?.forEach((x: string) => {
    const [key, variant] = x.split('=');
    const variantsList = getVariantsArray(context, key || '');

    const targetIndex = variantsList.findIndex((vr: string) => vr === variant);
    if (targetIndex !== -1) {
      context.override(key || '', targetIndex);
    }
    forcedExperiments.push(key || '');
  });

  const searchParams = new URLSearchParams(window?.location?.search);
  const forceExperimentsToControl = searchParams.has('force_control');

  if (!forceExperimentsToControl) return;

  context.data().experiments?.map(experiment => {
    const variantsList = getVariantsArray(context, experiment.name);

    if (!forcedExperiments.includes(experiment.name)) {
      const targetIndex = variantsList.findIndex((vr: string) => vr === 'control');
      if (targetIndex !== -1) {
        context.override(experiment.name, targetIndex);
      }
    }
  });
}
